import React from "react";
import { Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui"; // import PropTypes from 'prop-types';
// import { Debug } from './Debug';

import { Grid, Avatar, AccessTimeIcon, DeleteIcon, AddCircleOutlineOutlinedIcon, RemoveCircleOutlineOutlinedIcon, CheckCircleOutlineOutlinedIcon, IconButton, TextEditor, List, ListItem, ListItemAvatar, ListItemSecondaryAction, Typography, DatePicker, makeStyles } from "../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px"
    },
    form: {
      display: "flex"
    },
    mr30: {
      "margin-right": "30px"
    },
    labels: {
      margin: "8px 0"
    },
    flex: {
      display: "flex",
      "flex-wrap": "wrap",
      "padding-top": "10px"
    },
    w65: {
      width: "65%"
    },
    done: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    doing: {
      background: theme.palette.pending.main,
      color: theme.palette.primary.contrastText
    },
    pending: {
      background: "#b7b6b682",
      color: theme.palette.error.contrastText
    }
  };
});

var EditTaskForm = function EditTaskForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      translation = _ref.translation,
      heading = _ref.heading;
  // console.log('EditTaskForm values', values)
  var classes = useStyles();

  var avatar = function avatar(status) {
    var content, editClass;

    switch (status) {
      case "pending":
        content = /*#__PURE__*/React.createElement(AccessTimeIcon, null);
        editClass = classes.pending;
        break;

      case "doing":
        content = /*#__PURE__*/React.createElement(RemoveCircleOutlineOutlinedIcon, null);
        editClass = classes.doing;
        break;

      case "done":
        content = /*#__PURE__*/React.createElement(CheckCircleOutlineOutlinedIcon, null);
        editClass = classes.done;
        break;

      default:
        content = /*#__PURE__*/React.createElement(AccessTimeIcon, null);
        editClass = classes.pending;
        break;
    }

    return /*#__PURE__*/React.createElement(Avatar, {
      className: editClass
    }, " ", content);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "name",
    name: "name",
    label: translation ? translation.inputs.name : "Task name",
    placeholder: translation ? translation.inputs.name : "Task name",
    component: TextField,
    className: [classes.mr30, classes.w65].join(" "),
    margin: "normal",
    variant: "outlined"
  }), " ", !heading && /*#__PURE__*/React.createElement(Field, {
    name: "details",
    label: "Detalles"
  }, function (_ref2) {
    var field = _ref2.field;
    return /*#__PURE__*/React.createElement(TextEditor, {
      value: field.value,
      mode: mode,
      onChange: field.onChange(field.name)
    });
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 4,
    className: classes.editor
  }, !heading && !values.repeat ? /*#__PURE__*/React.createElement(Field, {
    "data-cy": "date",
    name: "date",
    label: translation ? translation.inputs.date : "Limit date",
    className: classes.mr30,
    component: DatePicker,
    format: "DD/MM/YYYY",
    value: values.date || null,
    disabled: mode === "view"
  }) : [!heading && /*#__PURE__*/React.createElement(Typography, {
    className: classes.labels,
    variant: "body1"
  }, translation ? translation.titles.recurring_dates : "This tasks repeats in these dates"), !heading && values.repeats && /*#__PURE__*/React.createElement(FieldArray, {
    name: "repeats",
    render: function render(_ref3) {
      var insert = _ref3.insert,
          remove = _ref3.remove,
          push = _ref3.push;
      return values.repeats.length > 0 ? values.repeats.map(function (field, index) {
        return /*#__PURE__*/React.createElement(List, {
          dense: true
        }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemAvatar, null, avatar(field.status)), /*#__PURE__*/React.createElement(Field, {
          "data-cy": "date",
          name: "repeats[".concat(index, "].date"),
          label: translation ? translation.inputs.date : "Limit date",
          className: classes.mr30,
          component: DatePicker,
          format: "DD/MM/YYYY",
          value: field.date,
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton, {
          edge: "end",
          "data-cy": "delete",
          color: "secondary",
          onClick: function onClick() {
            return remove(index);
          }
        }, /*#__PURE__*/React.createElement(DeleteIcon, null)), index === values.repeats.length - 1 && /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick() {
            return push({
              status: "pending",
              date: null
            });
          },
          edge: "end",
          "data-cy": "delete",
          color: "primary"
        }, /*#__PURE__*/React.createElement(AddCircleOutlineOutlinedIcon, null)))));
      }) : null;
    }
  })])));
};

export { EditTaskForm };